import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.install_app_id',
    viewPath: props.viewPath,
  })

  let changeFilter = useDataChange({
    context: 'tab',
    path: 'selected.apps_filter',
    viewPath: props.viewPath,
  })

  // we need to force the flowshortcut to forget the appid
  let changeFlowshortcuts = useDataChange({
    context: 'flow_shortcuts',
    path: 'installAppId',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(null)
    changeFlowshortcuts(null)
    changeFilter('directory')
  }
}
